import React from "react";
import { Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { selectSelectedTeam } from "../../features/clubhouse/clubhouseSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { Breakpoint } from "../../hooks/useBreakpoint";

const ClubhouseSidebar = ({
    breakpoint,
    toggleNavbar,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
}): React.JSX.Element => {
    const selectedTeam = useAppSelector(selectSelectedTeam);

    const routePrefix = `/coachs-clubhouse/team/${selectedTeam?.id}`;

    return (
        <Stack gap={2}>
            <Link
                to={`${routePrefix}`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Team Home
            </Link>
            <Link
                to={`${routePrefix}/registrations`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Tournament Registrations
            </Link>
            <Link
                to={`${routePrefix}/schedule`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Team Schedule
            </Link>
            <Link
                to={`${routePrefix}/roster`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Roster
            </Link>
            <Link
                to={`${routePrefix}/coi`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Cert. of Insurance
            </Link>
            <Link
                to={`/coachs-clubhouse/rules`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Tournament Rules
            </Link>
        </Stack>
    );
};

export default ClubhouseSidebar;
